import { Paragraph, Tag, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { humanReadableDate } from '../../utils';
import { ProposalDetailsContainerStyled } from './style';

type JobInformationPropsType = {
  cost?: number;
  createdAt?: string;
  designApproach?: string;
  experience?: string;
  notes?: string;
  numberOfExperience?: string;
  pastClients?: string[];
  pastProject?: string[];
  proposalStatus?: string;
  qualification?: string;
  riskAssessment?: string;
  specification?: string;
  jobTitle?: string;
  pricing?: string;
  shippingAddress?: string;
  status?: string;
  logoResolution?: string;
};

const TechnicianProposalInformation = ({
  jobTitle,
  createdAt,
  experience,
  notes,
  designApproach,
  qualification,
  riskAssessment,
  specification,
  status,
  pastClients,
  cost,
}: JobInformationPropsType) => {
  return (
    <ProposalDetailsContainerStyled>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="normal"
          strong
          fontColor="secondary"
          className="section-title"
        >
          PROPOSAL INFORMATION
        </Typography>
        <Tag
          type={
            status === 'DECLINE' || status === 'REJECT' ? 'danger' : 'success'
          }
        >
          {status}
        </Tag>
      </div>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Job Title
          </Typography>
          <Typography className="value">{jobTitle}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Proposal Create At :
          </Typography>
          <Typography className="value">
            {humanReadableDate(createdAt)}
          </Typography>
        </InfoRowStyled>

        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Cost :
          </Typography>
          <Typography className="value">{cost}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Experience :
          </Typography>
          <Typography className="value">{experience}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Design Approach :
          </Typography>
          {/* <InfoRowStyled className="value">{designApproach}</InfoRowStyled> */}
          <Typography className="value">{designApproach}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Past Clients :
          </Typography>
          <Typography className="value"> {pastClients}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Qualification :
          </Typography>
          <Typography className="value">{qualification}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Risk Assessment :
          </Typography>
          <Typography className="value">{riskAssessment}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Specification :
          </Typography>
          <Typography className="value">{specification}</Typography>
        </InfoRowStyled>
        <InfoRowStyled $direction="column">
          <Typography className="title" fontColor="dark">
            Notes :
          </Typography>
          <div className="value">
            <Paragraph text={notes} />
          </div>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </ProposalDetailsContainerStyled>
  );
};

export default TechnicianProposalInformation;
